{
  "name": "@codepack/workflow-cli",
  "version": "0.2.5",
  "description": "AI-powered workflow management CLI for developers",
  "keywords": [
    "workflow",
    "cli",
    "ai",
    "development",
    "automation",
    "codepack"
  ],
  "author": "CodePack Team",
  "license": "MIT",
  "publishConfig": {
    "access": "public"
  },
  "bin": {
    "workflow": "dist/cli.js",
    "wf": "dist/cli.js"
  },
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "files": [
    "dist",
    "templates",
    "README.md",
    "CHANGELOG.md",
    "LICENSE"
  ],
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "clean": "rm -rf dist",
    "type-check": "tsc --noEmit",
    "lint": "eslint src --ext .ts",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "prepublishOnly": "pnpm build"
  },
  "dependencies": {
    "chalk": "^5.3.0",
    "chokidar": "^4.0.0",
    "commander": "^14.0.0",
    "console-table-printer": "^2.12.1",
    "cosmiconfig": "^9.0.0",
    "crypto-js": "^4.2.0",
    "execa": "^9.6.0",
    "fs-extra": "^11.3.0",
    "gray-matter": "^4.0.3",
    "inquirer": "^12.5.0",
    "js-yaml": "^4.1.0",
    "ora": "^8.2.0",
    "picocolors": "^1.1.0",
    "prompts": "^2.4.2",
    "uuid": "^11.0.4",
    "zod": "^3.24.1"
  },
  "devDependencies": {
    "@types/crypto-js": "^4.2.2",
    "@types/fs-extra": "^11.0.4",
    "@types/inquirer": "^9.0.8",
    "@types/js-yaml": "^4.0.9",
    "@types/node": "^24.0.0",
    "@types/prompts": "^2.4.9",
    "@types/uuid": "^10.0.0",
    "tsup": "^8.0.1",
    "typescript": "^5.8.3",
    "vitest": "^3.2.0"
  },
  "engines": {
    "node": ">=20.0.0"
  }
}
